module.exports = __webpack_public_path__ + "img/service1.daf08b5a.png";